import React from 'react';
import { Row } from '../row';
import { Checkbox as MCheckbox } from '@mui/material';
import { Text } from '../text';

export const Checkbox = (props) => {
  const checkProps = props.checkProps || {};

  return (
    <Row onClick={props.onClick} className="cbrow" data-testid={props['data-testid']}>
      <MCheckbox
        className={props.className}
        {...checkProps}
        slotProps={props.checkboxTestId ? { input: { 'data-testid': props.checkboxTestId } } : undefined}
        checked={props.checked}
        onChange={props.onChange}
      />
      {props.label && <Text>{props.label}</Text>}
    </Row>
  );
};
